import {authStoreKey} from '@blesk-frontend/auth';
import {Loader, Page} from '@blesk-frontend/ui';
import {Link} from '@tanstack/react-router';
import {useState} from 'react';
import {AuthForm, AuthPage, AuthPolicyFooter} from '../components';

export const AuthSignInPage = () => {
  const [code] = useState(sessionStorage.getItem('inviteCode'));

  const token: string | undefined = JSON.parse(localStorage.getItem(authStoreKey) ?? '{}')?.state
    ?.token;

  if (token) {
    return (
      <Page className="flex flex-col items-center justify-center gap-4 text-center">
        <Loader />
      </Page>
    );
  }

  return (
    <AuthPage footer={<AuthPolicyFooter />}>
      <h1 className="text-center text-title-h1">Войти в Blesk</h1>

      {code && (
        <div className="text-center text-paragraph-sm">
          Авторизуйтесь, чтобы присоединиться к команде
        </div>
      )}

      <AuthForm />

      {!import.meta.env.VITE_ON_PREMISE_CLIENT_ID && (
        <div className="w-full text-center text-paragraph-sm">
          Ещё нет аккаунта?{' '}
          <Link className="text-brand-secondary" to="/auth/signup">
            Зарегистрируйтесь
          </Link>
        </div>
      )}
    </AuthPage>
  );
};
